// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__3PfPA","left":"Virtual_left__jVZto","wrapper":"Virtual_wrapper__KI6Fe"};